import './App.css';
import CodeGenerator from './CodeGenerator';
import Footer from './Footer';
import logo from './sc.png';
import Version from './version';
import {SnackbarProvider} from "notistack";
import React from "react";


function App() {
  return (
    <div className="App pb-5">
        <img src={logo} className="logo" alt="logo" />
        <div className="text-muted">
            <Version/>
        </div>
        <SnackbarProvider
        maxSnack={6}
        anchorOrigin={{vertical: 'top', horizontal: 'right'}
        }>
            <CodeGenerator />
        </SnackbarProvider>
        <Footer />
    </div>
  );
}

export default App;
